import React from "react";
import ContactButton from "./ContactButton";
import "./ContactCTA.css";

const joinClasses = (...classes) => classes.filter(Boolean).join(" ");

const renderAction = (action, variant) => {
  if (!action || !action.label) return null;
  const buttonProps = { variant, className: action.className, onClick: action.onClick, type: action.type };
  if (action.to) return <ContactButton to={action.to} {...buttonProps}>{action.label}</ContactButton>;
  if (action.href) return <ContactButton href={action.href} external={action.external} {...buttonProps}>{action.label}</ContactButton>;
  if (action.onClick) return <ContactButton {...buttonProps}>{action.label}</ContactButton>;
  return null;
};

const ContactCTA = ({
  kicker,
  title,
  description,
  primaryAction,
  secondaryAction,
  className = "",
  wrapClassName = "",
  copyClassName = "",
  actionsClassName = "",
  ariaLabel = "Connect with Astra Concepts",
  children,
}) => {
  const hasActions = Boolean(primaryAction || secondaryAction);

  return (
    <section className={joinClasses("contact-panel", className)} aria-label={ariaLabel}>
      <div className={joinClasses("contact-wrap", wrapClassName)}>
        <div className={joinClasses("contact-copy", copyClassName)}>
          {kicker && <p className="contact-kicker">{kicker}</p>}
          {title && <h2 className="contact-title">{title}</h2>}
          {description && <p className="contact-desc">{description}</p>}
          {children}
        </div>
        {hasActions && (
          <div className={joinClasses("contact-actions", actionsClassName)}>
            {renderAction(primaryAction, "primary")}
            {renderAction(secondaryAction, "secondary")}
          </div>
        )}
      </div>
    </section>
  );
};

export default ContactCTA;
